<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" @click="$emit('click')">
		<g fill="none" fill-rule="evenodd">
			<g fill="#9B9B9B" fill-rule="nonzero">
				<g>
					<g>
						<g>
							<path d="M12.246 2.112H9.502C9.365.925 8.355 0 7.132 0S4.9.925 4.763 2.112H2.019c-1.11 0-2.013.903-2.013 2.014v.103c0 .848.528 1.575 1.272 1.87v9.513c0 1.11.904 2.014 2.014 2.014h7.681c1.11 0 2.014-.903 2.014-2.014V6.1c.744-.296 1.272-1.023 1.272-1.871v-.103c0-1.11-.903-2.014-2.013-2.014zM7.132.955c.696 0 1.277.499 1.405 1.157H5.728c.129-.658.71-1.157 1.404-1.157zm4.9 14.657c0 .584-.475 1.06-1.059 1.06H3.292c-.584 0-1.059-.476-1.059-1.06v-9.37h9.799v9.37zM13.304 4.23c0 .584-.475 1.059-1.058 1.059H2.019c-.583 0-1.058-.475-1.058-1.06v-.102c0-.584.475-1.06 1.058-1.06h10.227c.583 0 1.058.476 1.058 1.06v.103z" transform="translate(-646.000000, -481.000000) translate(152.000000, 347.000000) translate(494.000000, 134.000000)"/>
							<path d="M4.572 15.45c.264 0 .478-.214.478-.478V9.596c0-.264-.214-.478-.478-.478-.263 0-.477.214-.477.478v5.376c0 .264.214.478.477.478zM7.132 15.45c.264 0 .478-.214.478-.478V9.596c0-.264-.214-.478-.478-.478-.263 0-.477.214-.477.478v5.376c0 .264.214.478.477.478zM9.693 15.45c.263 0 .477-.214.477-.478V9.596c0-.264-.214-.478-.477-.478-.264 0-.478.214-.478.478v5.376c0 .264.214.478.478.478z" transform="translate(-646.000000, -481.000000) translate(152.000000, 347.000000) translate(494.000000, 134.000000)"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'trash-icon',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/trash-icon.vue